document.addEventListener('alpine:init', () => {
    Alpine.data('fmSelect', (cfg) => ({
        open: false,
        name: cfg.name ?? '',
        value: cfg.value ?? null,
        items: cfg.items ?? [],

        toggle() { this.open = !this.open },
        close() { this.open = false },

        pick(v) {
            this.value = v
            this.open = false
        },

        selectedLabel() {
            return this.items.find(i => i.value === this.value)?.label ?? 'Выберите'
        },
    }))
})
